import React from 'react';
import posthog from 'posthog-js';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import './Footer.css';

const Footer: React.FC = () => {
  return (
    <motion.footer
      className="footer"
      initial={{ opacity: 0, y: 30 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.8, ease: "easeOut" }}
      viewport={{ once: true, margin: "-100px" }}
    >
      <div className="footer-content">
        <div className="footer-left">
          <p className="footer-copyright">&copy; 2026 CODEC422. All rights reserved.</p>
        </div>
        <div className="footer-right">
          <div className="footer-links">
            <a
              href="mailto:team@codec422.com"
              onClick={() => posthog.capture('footer_link_clicked', { target: 'team_licenses_email' })}
            >
              Team Licenses
            </a>
            <a
              href="https://codec422.com/portal"
              target="_blank"
              rel="noopener noreferrer"
              onClick={() => posthog.capture('footer_link_clicked', { target: 'manage_devices_portal' })}
            >
              Manage Devices
            </a>
            <Link to="/faq" onClick={() => posthog.capture('footer_link_clicked', { target: 'faq' })}>FAQ</Link>
          </div>
        </div>
      </div>
    </motion.footer>
  );
};

export default Footer; 